<template>
  <RevContentBlock
    class="flex justify-end px-56 py-16"
    :image-props
    :surtitle="i18n(translations.surtitle, { taskNumber: 0 })"
    :title="i18n(translations.title)"
  >
    <RevLink :to="{ name: ROUTE_NAMES.CUSTOMER_CARE.ALL_REQUESTS }">
      <span class="body-1-bold pt-56">
        {{ i18n(translations.description) }}
      </span>
    </RevLink>
  </RevContentBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContentBlock } from '@ds/components/ContentBlock'
import { RevLink } from '@ds/components/Link'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './NoOpenTaskBlock.translations'

const i18n = useI18n()

const imageProps = {
  alt: '',
  height: 336,
  src: '/img/customer-care/buoy-boy.svg',
  width: 327,
  style: 'max-height: 336px',
}
</script>
